<template>
  <div class="text-left">
    <label class="pdf-drop" :class="{ 'pdf-drop--over': over, 'pdf-drop--error': error, 'pdf-drop--multiple': multiple }"
      @dragover.prevent="over = true" @dragleave.prevent="over = false" @drop.prevent="onDrop">
      <input ref="input" type="file" accept="application/pdf,.pdf" :multiple="multiple" class="pdf-drop__input" @change="onPick" />
      <template v-if="!multiple && value">
        <v-icon color="#a8201a">mdi-file-pdf-box</v-icon>
        <span class="pdf-drop__name">{{ value.name }}</span>
        <v-btn icon small @click.prevent.stop="$emit('input', null)" aria-label="Quitar archivo">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-icon color="#1f6f78">{{ multiple ? "mdi-tray-arrow-up" : "mdi-paperclip" }}</v-icon>
        <span class="pdf-drop__text">
          <b>{{ multiple ? "Elegí los PDF" : "Elegí un PDF" }}</b> {{ multiple ? "o arrastralos todos juntos acá" : "o arrastralo acá" }}
        </span>
        <span v-if="hint" class="pdf-drop__hint">{{ hint }}</span>
      </template>
    </label>
  </div>
</template>

<script>
// Zona para elegir o arrastrar PDF. v-model: File (simple) o File[] (multiple, se van sumando)
export default {
  name: "PdfDropZone",
  props: {
    value: null,
    multiple: Boolean,
    error: Boolean,
    hint: String,
  },
  data() {
    return {
      over: false,
    };
  },
  methods: {
    onPick(event) {
      this.add(Array.from(event.target.files || []));
      // Permite volver a elegir el mismo archivo despues de quitarlo
      event.target.value = "";
    },
    onDrop(event) {
      this.over = false;
      this.add(Array.from(event.dataTransfer.files || []));
    },
    add(files) {
      const pdfs = files.filter((file) => file.type == "application/pdf" || /\.pdf$/i.test(file.name));
      if (pdfs.length < files.length) this.$toast.error("Solo se pueden subir archivos PDF.", "Error");
      if (pdfs.length == 0) return;

      if (!this.multiple) {
        this.$emit("input", pdfs[0]);
        return;
      }
      // Sin repetir el mismo archivo (nombre y tamaño)
      const current = this.value || [];
      const added = pdfs.filter((file) => !current.some((f) => f.name == file.name && f.size == file.size));
      this.$emit("input", current.concat(added));
    },
  },
};
</script>

<style scoped>
.pdf-drop {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 76px;
  padding: 0 24px;
  box-sizing: border-box;
  border: 1.5px dashed #8a9ba0;
  border-radius: 8px;
  background: #f7fafa;
  cursor: pointer;
  color: #3d5158;
  font-size: 14px;
  text-align: center;
}
.pdf-drop--multiple {
  flex-direction: column;
  gap: 4px;
  min-height: 112px;
}
.pdf-drop:hover,
.pdf-drop--over {
  border-color: #1f6f78;
  background: #f1f7f8;
}
.pdf-drop:focus-within {
  outline: 2px solid #1f6f78;
  outline-offset: 2px;
}
.pdf-drop--error {
  border-color: #c62828;
}
.pdf-drop__input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.pdf-drop__text {
  font-size: 15px;
  color: #1d2b30;
}
.pdf-drop__text b {
  font-weight: 500;
  color: #1f6f78;
}
.pdf-drop__hint {
  font-size: 13px;
  color: #4d6269;
}
.pdf-drop__name {
  flex: 1;
  min-width: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1d2b30;
}
</style>
